import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { ComponentsModule } from 'src/app/extensions/components/components.module';
import { DateInputsModule } from '@progress/kendo-angular-dateinputs';
import '@progress/kendo-angular-intl/locales/ro/all';
import { FormsModule } from '@angular/forms';
import { PaymentRoutingModule } from './payment-routing.module';
import { PaymentListComponent } from './payment-list/payment-list.component';
import { PaymentListFilterComponent } from './payment-list/payment-list-filter.component.ts/payment-list-filter.component';
import { PaymentListViewComponent } from './payment-list/payment-list-view/payment-list-view.component';
import { PaymentCardViewComponent } from './payment-list/payment-card-view/payment-card-view.component';
import { PaymentDetailComponent } from './payment-detail/payment-detail.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { PipeModule } from 'src/app/extensions/pipes/pipe.module';
import { ClipboardModule } from '@angular/cdk/clipboard';
import { WindowEventsService } from 'src/app/extensions/services/window-events.services';

@NgModule({
  imports: [
    CommonModule,
    PaymentRoutingModule,
    TranslateModule.forChild(),
    ComponentsModule,
    DateInputsModule,
    PipeModule,
    FormsModule,
    NgbModule,
    ClipboardModule,
  ],
  declarations: [
    PaymentListComponent,
    PaymentListFilterComponent,
    PaymentListViewComponent,
    PaymentCardViewComponent,
    PaymentDetailComponent,
  ],
  providers: [WindowEventsService],
})
export class PaymentModule {}
